import { useQueryClient } from "@tanstack/react-query";
import { todoTasksCountQueryKey, useTodoTasksCount } from "@api/task.api";
import { useNatsSubscription } from "@hooks/useNatsSubscription";
import { useScope } from "@state/scopeContext.lib";

/**
 * The workspace's open task count, refetched whenever a thread notification
 * arrives. Undefined while loading.
 */
export const useLiveTodoTasksCount = () => {
    const { data: todoTasksCount, isLoading } = useTodoTasksCount();
    const { workspaceId, activeWorkspaceKey } = useScope();
    const queryClient = useQueryClient();
    useNatsSubscription(
        workspaceId
            ? `workspaces.${workspaceId}.notifications.threads.>`
            : null,
        {
            onMessage: () => {
                queryClient.invalidateQueries({
                    queryKey: todoTasksCountQueryKey(activeWorkspaceKey),
                });
            },
        },
    );

    return isLoading ? undefined : todoTasksCount;
};
